var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarKebab = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.498047,
  y: 19.7002,
  width: 19,
  height: 19,
  rx: 9.5,
  transform: "rotate(-90 0.498047 19.7002)",
  stroke: "#6B5CE8"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.68359 11.4502C4.43637 11.4502 4.19469 11.3769 3.98913 11.2395C3.78357 11.1022 3.62335 10.907 3.52874 10.6785C3.43414 10.4501 3.40938 10.1988 3.45761 9.95633C3.50584 9.71386 3.6249 9.49113 3.79971 9.31631C3.97453 9.1415 4.19726 9.02244 4.43973 8.97421C4.68221 8.92598 4.93354 8.95074 5.16195 9.04534C5.39036 9.13995 5.58558 9.30017 5.72293 9.50573C5.86028 9.71129 5.93359 9.95297 5.93359 10.2002C5.93359 10.5317 5.8019 10.8497 5.56748 11.0841C5.33306 11.3185 5.01512 11.4502 4.68359 11.4502ZM8.74609 10.2002C8.74609 10.4474 8.81941 10.6891 8.95676 10.8947C9.09411 11.1002 9.28933 11.2604 9.51774 11.355C9.74615 11.4497 9.99748 11.4744 10.24 11.4262C10.4824 11.3779 10.7052 11.2589 10.88 11.0841C11.0548 10.9093 11.1738 10.6865 11.2221 10.4441C11.2703 10.2016 11.2456 9.95025 11.1509 9.72184C11.0563 9.49343 10.8961 9.29821 10.6906 9.16086C10.485 9.02351 10.2433 8.95019 9.99609 8.95019C9.66457 8.95019 9.34663 9.08189 9.11221 9.31631C8.87779 9.55073 8.74609 9.86867 8.74609 10.2002ZM14.0586 10.2002C14.0586 10.4474 14.1319 10.6891 14.2693 10.8947C14.4066 11.1002 14.6018 11.2604 14.8302 11.355C15.0586 11.4497 15.31 11.4744 15.5525 11.4262C15.7949 11.3779 16.0177 11.2589 16.1925 11.0841C16.3673 10.9093 16.4863 10.6865 16.5346 10.4441C16.5828 10.2016 16.5581 9.95025 16.4634 9.72184C16.3688 9.49343 16.2086 9.29821 16.0031 9.16086C15.7975 9.02351 15.5558 8.95019 15.3086 8.95019C14.9771 8.95019 14.6591 9.08189 14.4247 9.31631C14.1903 9.55073 14.0586 9.86867 14.0586 10.2002Z",
  fill: "#6B5CE8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarKebab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_kebab.dc2cce4aa92d09376953f10c48f9c0cc.svg";